import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { TakeOverSource, TakeOverStatus } from './type';

export const useTextToSpeech = (text: string | null, depend?: any) => {
  const speecheRef = useRef<any>(null);
  useEffect(() => {
    if (text && depend) {
      speecheRef.current = new SpeechSynthesisUtterance(text);

      speecheRef.current.rate = 1; // 正常语速是1
      speecheRef.current.volume = 1; // 音量范围 0 到 1
      speecheRef.current.lang = 'zh-CN'; // 中文

      // 开始播报
      window.speechSynthesis.speak(speecheRef.current);
    }
    return () => {
      if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel();
      }
    };
  }, [text, depend]);
};
export const useIsTakeOverBySelf = () => {
  const takeOverStatus = useSelector(
    (state: RootState) => state.realtime?.realtimeData?.takeOverStatus
  );
  const takeOverSource = useSelector(
    (state: RootState) => state.realtime?.realtimeData?.takeOverSource
  );
  const takeOverUserName = useSelector(
    (state: RootState) => state.realtime?.realtimeData?.takeOverUserName
  );
  const takeOverCockpitNumber = useSelector(
    (state: RootState) => state.realtime?.realtimeData?.takeOverCockpitNumber
  );
  const cockpitNumber = useSelector(
    (state: RootState) => state.newCommon?.cockpitNumber
  );
  const userName = useSelector(
    (state: RootState) => state.login?.userInfo?.userName
  );

  const isTakeOverBySelf =
    takeOverStatus === TakeOverStatus.TAKEOVER &&
    takeOverSource === TakeOverSource.REMOTE_JOYSTICK &&
    !!takeOverUserName &&
    takeOverUserName === userName &&
    !!takeOverCockpitNumber &&
    takeOverCockpitNumber === cockpitNumber;

  return isTakeOverBySelf;
};
